(function (global) {
  'use strict';
  // Mirrors the selected swatch (image or color) into package color pills. Presentation only.
  function syncColorSwatch(section, swatches, color) {
    var pick = null;
    swatches.forEach(function (s) { if (String(s.dataset.clSwatch || '').trim().toLowerCase() === String(color || '').trim().toLowerCase()) pick = s; });
    var img = pick && pick.querySelector('img');
    var chip = pick && pick.querySelector('span[style]');
    var bg = img && img.currentSrc ? 'center / cover no-repeat url("' + (img.currentSrc || img.src).replace(/"/g, '%22') + '")' : (img ? 'center / cover no-repeat url("' + img.src.replace(/"/g, '%22') + '")' : (chip ? chip.style.background : ''));
    section.querySelectorAll('[data-cl-selected-color-swatch]').forEach(function (node) {
      node.style.background = bg || '';
      node.hidden = !bg;
    });
  }
  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }
  // Display estimate only. Never mutate resolved Shopify prices or cart payloads.
  function bundleDisplayPrice(total, count, automatic) {
    var percent = automatic ? (Number(count) === 2 ? 10 : Number(count) === 4 ? 20 : 0) : 0;
    var discounted = Math.round(Number(total) * (100 - percent) / 100);
    return { total: discounted, unit: discounted / quantity(count), percent: percent };
  }

  function parseJSON(value, fallback) {
    try {
      var parsed = JSON.parse(value);
      return parsed == null ? fallback : parsed;
    } catch (_error) {
      return fallback;
    }
  }

  function resolveVariant(variants, color, colorIndex, titleMatch) {
    return (variants || []).find(function (variant) {
      return variant.available &&
        (!titleMatch || normalize(variant.title).indexOf(normalize(titleMatch)) !== -1) &&
        (!color || colorIndex < 0 || normalize((variant.options || [])[colorIndex]) === normalize(color));
    }) || null;
  }

  function quantity(value) {
    return Math.max(1, Math.floor(Number(value) || 1));
  }

  function chooseColors(current, picked, limit) {
    var values = current.slice(0, quantity(limit));
    var index = values.findIndex(function (value) { return normalize(value) === normalize(picked); });
    if (index >= 0) return values.length > 1 ? values.filter(function (_, i) { return i !== index; }) : values;
    if (values.length >= quantity(limit)) values.pop();
    return values.concat(picked);
  }

  // Exact per-unit color slots: always `count` entries, duplicates allowed, index i = unit i.
  // Shorter legacy arrays (unique colors) are expanded cyclically, so old saved state still maps.
  function unitColors(current, count, fallback) {
    var src = (current || []).filter(function (value) { return normalize(value); });
    if (!src.length && normalize(fallback)) src = [fallback];
    var out = [];
    for (var i = 0; src.length && i < quantity(count); i++) out.push(src[i % src.length]);
    return out;
  }
  // Changes exactly one unit; every other slot (and the array length) is preserved.
  function setUnitColor(units, index, picked) {
    var next = (units || []).slice();
    if (index >= 0 && index < next.length && normalize(picked)) next[index] = picked;
    return next;
  }

  // Child product items take precedence over bundle products, then main variants.
  // A missing matching color always makes the package unavailable.
  function resolvePackage(config, color, variants, colorIndex) {
    var colors = (Array.isArray(color) ? color : [color]).filter(function (value) { return normalize(value); });
    color = colors[0] || '';
    if (config.simple) return resolveSimplePackage(config, colors, variants, colorIndex);
    if (config.items && config.items.length) {
      var slots = config.items.reduce(function (count, item) { return count + (item.colorIndex >= 0 ? quantity(item.quantity) : 0); }, 0);
      if (colors.length > 1 && colors.length > slots) return null;
      var cursor = 0;
      var lines = [];
      config.items.forEach(function (item) {
        for (var i = 0; i < quantity(item.quantity); i++) {
          var chosen = item.colorIndex >= 0 && colors.length ? colors[cursor++ % colors.length] : '';
          var variant = resolveVariant(item.variants, chosen, item.colorIndex, '');
          lines.push(variant ? { variant: variant, quantity: 1 } : null);
        }
      });
      if (lines.some(function (line) { return !line; })) return null;
      return {
        id: lines[0].variant.id,
        price: lines.reduce(function (total, line) { return total + Number(line.variant.price) * line.quantity; }, 0),
        compare_at_price: lines.reduce(function (total, line) {
          return total + Math.max(Number(line.variant.price), Number(line.variant.compare_at_price) || 0) * line.quantity;
        }, 0),
        available: true,
        packageItems: cartItems({ packageItems: lines.map(function (line) { return { id: line.variant.id, quantity: line.quantity }; }) }, [])
      };
    }
    // A single bundle SKU cannot encode independently chosen component colors.
    if (colors.length > 1) return null;
    if (config.bundleVariants) {
      return resolveVariant(config.bundleVariants, color, config.bundleColorIndex, '');
    }
    return resolveVariant(variants, color, colorIndex, config.match || '');
  }

  // Simple packs: N units of the section's main product, one real variant per selected color.
  // An optional gift needs a resolved, available variant AND a manual discount code; otherwise
  // the pack is unavailable (never a silent fallback or a gift charged at full price).
  function resolveSimplePackage(config, colors, variants, colorIndex) {
    var index = config.colorIndex != null ? Number(config.colorIndex) : Number(colorIndex);
    var code = String(config.code || '').trim();
    var gift = config.gift || null;
    if (gift && (gift.state !== 'ok' || !gift.id || (!config.automatic && !code))) return null;
    if (index >= 0 && !colors.length) return null;
    var base = resolvePackage({ items: [{ variants: config.variants || variants, colorIndex: index, quantity: config.quantity }] }, colors, variants, index);
    if (!base) return null;
    base.simple = true;
    base.discountCode = code;
    base.gift = gift ? { id: gift.id, quantity: quantity(gift.quantity) } : null;
    return base;
  }

  // Every line of a managed purchase is tagged with private properties so later checks and
  // rollbacks only ever touch lines created by this section; unrelated cart lines are untouched.
  function packageCartItems(selectedVariant, addons, tag) {
    var items = cartItems(selectedVariant, addons).map(function (item) {
      return { id: item.id, quantity: item.quantity, properties: Object.assign({}, tag) };
    });
    if (items.length && selectedVariant.gift) {
      items.push({ id: selectedVariant.gift.id, quantity: selectedVariant.gift.quantity, properties: Object.assign({}, tag, { _clp_gift: '1' }) });
    }
    return items;
  }

  // Known APPLIED discount codes from the documented Ajax cart shape: discount applications of
  // type "discount_code" (cart level and per-line allocations). Automatic/script titles are
  // never treated as codes. An optional full `discount_codes` list is used when present (only
  // entries not reported as inapplicable). Dormant codes Shopify does not report cannot be known.
  function discountCodes(cart) {
    var out = [];
    function push(code) {
      code = String(code || '').trim();
      if (code && !out.some(function (value) { return normalize(value) === normalize(code); })) out.push(code);
    }
    function app(application) { if (application && application.type === 'discount_code') push(application.title || application.code); }
    if (Array.isArray(cart && cart.discount_codes)) {
      cart.discount_codes.forEach(function (entry) { if (entry && entry.applicable !== false) push(entry.code || (typeof entry === 'string' ? entry : '')); });
    }
    ((cart && cart.cart_level_discount_applications) || []).forEach(app);
    ((cart && cart.items) || []).forEach(function (line) {
      (line.line_level_discount_allocations || []).forEach(function (allocation) { app(allocation && allocation.discount_application); });
    });
    return out;
  }
  function hasCode(cart, code) {
    return discountCodes(cart).some(function (value) { return normalize(value) === normalize(code); });
  }

  // Keeps unrelated codes, drops every package code owned by this section (stale codes from a
  // previously added or switched pack), then appends the wanted package/add-on codes.
  function mergeDiscountCodes(existing, managed, wanted) {
    var owned = (managed || []).map(normalize);
    var out = [];
    (existing || []).concat(wanted || []).forEach(function (code, i) {
      code = String(code || '').trim();
      if (!code) return;
      if (i < (existing || []).length && owned.indexOf(normalize(code)) !== -1) return;
      if (!out.some(function (value) { return normalize(value) === normalize(code); })) out.push(code);
    });
    return out.join(',');
  }

  function lineProps(line) { return (line && line.properties) || {}; }
  function linePrice(line) { return Number(line.final_line_price != null ? line.final_line_price : line.line_price); }

  // Verifies Shopify's returned cart, not our own assumption: the gift lines from this attempt
  // must match the gift variant, have the expected quantity and a final line price of exactly 0,
  // and the pack code must be reported by Shopify as an applied discount_code application.
  function verifyGift(cart, sectionId, token, gift, code) {
    var ours = (cart && cart.items || []).filter(function (line) {
      var props = lineProps(line);
      return props._clp_section === String(sectionId) && props._clp_gift;
    });
    var current = ours.filter(function (line) { return lineProps(line)._clp_attempt === token; });
    var count = current.reduce(function (sum, line) { return sum + Number(line.quantity || 0); }, 0);
    var reason = '';
    // A code counts only when Shopify reports it as an applied discount_code application.
    var codeRejected = !!String(code || '').trim() && !hasCode(cart, code);
    var wrongVariant = gift && current.some(function (line) { return String(line.variant_id != null ? line.variant_id : line.id) !== String(gift.id); });
    if (gift && (!current.length || count !== quantity(gift.quantity) || wrongVariant)) reason = 'missing';
    else if (gift && current.some(function (line) { return !(linePrice(line) === 0); })) reason = 'price';
    else if (codeRejected) reason = 'code'; // applies to code-only packs too
    return {
      ok: !reason,
      reason: reason,
      stale: ours.filter(function (line) { return lineProps(line)._clp_attempt !== token && linePrice(line) > 0; }).map(function (line) { return line.key; })
    };
  }

  function cartItems(selectedVariant, addons) {
    if (!selectedVariant) return [];
    var items = [];
    function add(id, count) {
      if (!id) throw new Error('A configured cart item is missing its variant ID.');
      var existing = items.find(function (item) { return String(item.id) === String(id); });
      if (existing) existing.quantity += quantity(count);
      else items.push({ id: id, quantity: quantity(count) });
    }
    if (selectedVariant.packageItems) {
      selectedVariant.packageItems.forEach(function (item) { add(item.id, item.quantity); });
    } else {
      add(selectedVariant.id, 1);
    }
    (addons || []).forEach(function (item) { add(item.id, item.quantity); });
    return items;
  }

  function formatMoney(cents, format, showDecimals) {
    var template = format || '${{amount}}';
    var token = template.match(/\{\{\s*(\w+)\s*\}\}/);
    var type = token ? token[1] : 'amount';
    var decimals = typeof showDecimals === 'boolean' ? (showDecimals ? 2 : 0) : (type.indexOf('no_decimals') !== -1 ? 0 : 2);
    var comma = type.indexOf('comma_separator') !== -1;
    var thousands = comma ? '.' : type === 'amount_with_apostrophe_separator' ? "'" : ',';
    var parts = (Number(cents) / 100).toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    var value = parts.join(comma ? ',' : '.');
    // Shopify money formats may contain HTML; price nodes receive text only.
    var result = token ? template.replace(token[0], value) : value;
    if (!global.document) return result.replace(/<[^>]*>/g, '');
    var node = global.document.createElement('span');
    node.innerHTML = result;
    return node.textContent;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { bundleDisplayPrice: bundleDisplayPrice, hasCode: hasCode, resolveVariant: resolveVariant, resolvePackage: resolvePackage, cartItems: cartItems, formatMoney: formatMoney, chooseColors: chooseColors, unitColors: unitColors, setUnitColor: setUnitColor, packageCartItems: packageCartItems, mergeDiscountCodes: mergeDiscountCodes, discountCodes: discountCodes, verifyGift: verifyGift };
  }
  if (!global.document || global.__clutchLoopBuilderLoaded) return;
  global.__clutchLoopBuilderLoaded = true;

  // Refresh only after the purchase has been verified. This read is optional;
  // failure must open the real cart page, never repeat a cart mutation.
  async function openCart(section, destination) {
    var fallback = destination || section.dataset.clCartUrl;
    var drawer = global.document.querySelector('cart-drawer');
    var timer;
    try {
      if (!drawer || typeof drawer.renderContents !== 'function' || typeof drawer.onShowCartDrawer !== 'function') throw new Error('No compatible drawer');
      var id = drawer.dataset.sectionId;
      if (!id) throw new Error('Missing drawer section');
      var url = new URL(section.dataset.clCartUrl, global.location.origin);
      url.searchParams.set('sections', id + ',cart-icon-bubble');
      var sections = await Promise.race([
        (async function () {
          var response = await global.fetch(url.toString(), { credentials: 'same-origin', cache: 'no-store' });
          if (!response.ok) throw new Error('Cart drawer could not load');
          return response.json();
        })(),
        new Promise(function (_, reject) { timer = global.setTimeout(function () { reject(new Error('Cart drawer timed out')); }, 4000); })
      ]);
      if (!sections[id] || !sections['cart-icon-bubble']) throw new Error('Missing cart sections');
      var parser = new global.DOMParser();
      var freshBody = parser.parseFromString(sections[id], 'text/html').querySelector('.drawer__body');
      var currentBody = drawer.querySelector('.drawer__body');
      if (!freshBody || !currentBody) throw new Error('Incomplete cart drawer markup');
      currentBody.innerHTML = freshBody.innerHTML;
      var icon = global.document.getElementById('cart-icon-bubble');
      var iconDocument = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
      var freshIcon = iconDocument.querySelector('.shopify-section') || iconDocument.body;
      if (icon) {
        icon.innerHTML = freshIcon.innerHTML;
        if (typeof drawer.updateCartIcon === 'function') drawer.updateCartIcon(icon);
      }
      drawer.onShowCartDrawer({ preventDefault: function () {} }, section.querySelector('[data-cl-submit]'));
      // The supplied theme opens synchronously with .active. Never leave a
      // successful add invisible if a theme customization changes that contract.
      if (!drawer.classList.contains('active')) throw new Error('Cart drawer did not open');
    } catch (_) {
      global.location.assign(fallback);
    } finally { global.clearTimeout(timer); }
  }

  function initSection(section) {
    if (section._clpCleanup) return;
    var form = section.querySelector('[data-cl-product-form]');
    var script = section.querySelector('[data-cl-variants]');
    if (!form || !script) return;
    var variants = parseJSON(script.textContent, []);
    var colorIndex = Number(section.dataset.clColorOptionIndex);
    var moneyFormat = section.dataset.clMoneyFormat;
    var cards = Array.from(section.querySelectorAll('[data-cl-package]'));
    var swatches = Array.from(section.querySelectorAll('[data-cl-swatch]'));
    var addons = Array.from(section.querySelectorAll('[data-cl-addon]'));
    var anchorGroups = Array.from(section.querySelectorAll('[data-cl-anchors]')).map(function (node) {
      return global.ClutchLoopAnchors.mount(node, updateCommerce, money);
    });
    var anchorError = '';
    var checkouts = Array.from(section.querySelectorAll('[data-cl-checkout]')).map(function (node) { return global.ClutchLoopCheckout.mount(node, updateCommerce, money); });
    var galleries = Array.from(section.querySelectorAll('[data-cl-gallery]'));
    var buttons = Array.from(form.querySelectorAll('[data-cl-submit]'));
    var confirmedAddition = false, selectionRevision = 0;
    var variantInput = form.querySelector('[data-cl-variant-input]');
    var errorNode = section.querySelector('[data-cl-error-message]');
    var sticky = section.querySelector('[data-cl-sticky]');
    var stickySelect = section.querySelector('[data-cl-sticky-package]');
    var stickyButton = section.querySelector('[data-cl-sticky-submit]');
    var activeCard = cards.find(function (card) { return card.dataset.clDefault === 'true'; }) || cards[0] || null;
    var initialVariant = variants.find(function (variant) { return String(variant.id) === String(variantInput && variantInput.value); });
    var color = initialVariant && colorIndex >= 0 ? initialVariant.options[colorIndex] : '';
    var defaultColor = color;
    var colorsByCard = new Map();
    cards.forEach(function (card) { colorsByCard.set(card, unitColors([], card.dataset.clUnitCount, color)); });
    function selectedColors(card) { return colorsByCard.get(card) || (color ? [color] : []); }
    function uniqueColors(list) { return list.filter(function (value, i) { return list.findIndex(function (other) { return normalize(other) === normalize(value); }) === i; }); }
    function activateCard(card) {
      activeCard = card;
      var choices = selectedColors(card);
      color = choices[choices.length - 1] || '';
      updateCommerce();
      updateGalleries();
    }
    function swatchNode(name) {
      var source = swatches.find(function (swatch) { return normalize(swatch.dataset.clSwatch) === normalize(name); });
      var image = source && source.querySelector('img');
      var chip = source && source.querySelector('span[style]');
      // No configured swatch: fall back to the matching variant's real product image.
      var fallback = !image && variantImage(name);
      var node = image ? image.cloneNode(true) : global.document.createElement(fallback ? 'img' : 'span');
      if (fallback) { node.src = fallback; image = node; }
      node.className = 'clp-package__swatch';
      node.title = name;
      if (image) { node.alt = ''; if (node.removeAttribute) { node.removeAttribute('srcset'); node.removeAttribute('sizes'); } }
      else {
        node.setAttribute('aria-hidden', 'true');
        if (chip) node.style.background = chip.style.background;
        else node.className += ' clp-package__swatch--blank';
      }
      return node;
    }
    function variantImage(name) {
      if (colorIndex < 0) return '';
      var match = (variants || []).filter(function (variant) { return normalize((variant.options || [])[colorIndex]) === normalize(name); });
      var hit = match.find(function (variant) { return variant.available && (variant.featured_image || variant.image); }) || match.find(function (variant) { return variant.featured_image || variant.image; });
      var img = hit && (hit.featured_image || hit.image);
      return img ? (typeof img === 'string' ? img : img.src || '') : '';
    }
    // A color is offered per unit only if a full pack of that color resolves to real, available
    // variants (gift/code checks excluded: those disable the whole pack, not one color).
    function colorAvailable(card, name) {
      var config = configuration(card);
      if (config.simple) config = Object.assign({}, config, { gift: null, code: '' });
      return !!resolvePackage(config, unitColors([name], card.dataset.clUnitCount), variants, colorIndex);
    }
    function buildUnit(card, index, count) {
      var doc = global.document;
      var unit = doc.createElement('span');
      unit.className = 'clp-unit';
      unit.dataset.clUnit = String(index);
      var slot = doc.createElement('span');
      slot.className = 'clp-unit__swatch';
      var label = doc.createElement('span');
      label.className = 'clp-unit__name';
      var select = doc.createElement('select');
      select.className = 'clp-unit__select';
      select.setAttribute('data-cl-unit-select', String(index));
      select.setAttribute('aria-label', (card.dataset.clPackageTitle || '') + ': color for unit ' + (index + 1) + ' of ' + count);
      unit.appendChild(slot); unit.appendChild(label); unit.appendChild(select);
      // Native select: reliable on mobile and keyboard. Changes only this unit; the card click
      // listener is not needed (we activate the card here) so the event stops at the pill.
      function onUnitChange(event) {
        if (event && event.stopPropagation) event.stopPropagation();
        colorsByCard.set(card, setUnitColor(selectedColors(card), index, select.value));
        activeCard = card;
        color = select.value;
        updateCommerce();
        updateGalleries();
      }
      on(select, 'change', onUnitChange);
      on(select, 'click', function (event) { if (event && event.stopPropagation) event.stopPropagation(); if (activeCard !== card) activateCard(card); });
      // Custom listbox (real swatch image + name per row). The native select stays as a hidden,
      // unfocusable state bridge; without the helper asset the overlay select remains the control.
      var dropdown = null;
      var helper = global.ClutchLoopUnitDropdown;
      if (helper && dropdownRegistry) {
        dropdown = helper.attach({
          doc: doc,
          registry: dropdownRegistry,
          styleSource: unit,
          unavailableText: card.dataset.clUnavailable || section.dataset.clUnavailable || 'Unavailable',
          label: function (name) { return (card.dataset.clPackageTitle || '') + ': color for unit ' + (index + 1) + ' of ' + count + ', ' + name; },
          getValue: function () { return selectedColors(card)[index] || ''; },
          getOptions: function () { return unitOptions(card); },
          onChoose: function (value) { select.value = value; onUnitChange(null); }
        });
        unit.classList.toggle('clp-unit--custom', true);
        select.tabIndex = -1;
        select.setAttribute('aria-hidden', 'true');
        unit.appendChild(dropdown.button);
      }
      return { node: unit, slot: slot, label: label, select: select, dropdown: dropdown, name: null, signature: null };
    }
    function colorNames(card) {
      var names = [];
      var candidates = swatches.map(function (swatch) { return swatch.dataset.clSwatch; });
      if (colorIndex >= 0) (variants || []).forEach(function (variant) { candidates.push((variant.options || [])[colorIndex]); });
      candidates.concat(selectedColors(card)).forEach(function (name) { if (normalize(name) && !names.some(function (value) { return normalize(value) === normalize(name); })) names.push(name); });
      return names;
    }
    // Fresh option data for the custom dropdown (read at open time: never stale).
    function unitOptions(card) {
      return colorNames(card).map(function (name) {
        return { value: name, label: name, available: colorAvailable(card, name), swatch: function () { return swatchNode(name); } };
      });
    }
    function renderColorPill(card) {
      var holder = card.querySelector('[data-cl-bundle-swatches]');
      if (!holder) return;
      var choices = selectedColors(card);
      // Configured swatches first, then every real main-product color (deduped), then choices.
      // Products without a color option add nothing (no phantom options).
      var names = [];
      var candidates = swatches.map(function (swatch) { return swatch.dataset.clSwatch; });
      if (colorIndex >= 0) (variants || []).forEach(function (variant) { candidates.push((variant.options || [])[colorIndex]); });
      candidates.forEach(function (name) { if (normalize(name) && !names.some(function (value) { return normalize(value) === normalize(name); })) names.push(name); });
      choices.forEach(function (name) { if (!names.some(function (value) { return normalize(value) === normalize(name); })) names.push(name); });
      var available = names.map(function (name) { return colorAvailable(card, name); });
      var signature = names.join('|') + '#' + available.join('|');
      // Nodes are built once per card and then repainted, so an open select is never destroyed.
      if (!holder._clpUnits || holder._clpUnits.length !== choices.length) {
        (holder._clpUnits || []).forEach(function (unit) { if (unit.dropdown) unit.dropdown.destroy(); });
        holder.replaceChildren();
        holder._clpUnits = choices.map(function (_, i) { return buildUnit(card, i, choices.length); });
        holder._clpUnits.forEach(function (unit) { holder.appendChild(unit.node); });
      }
      holder._clpUnits.forEach(function (unit, i) {
        var name = choices[i];
        if (unit.signature !== signature) {
          unit.select.replaceChildren();
          names.forEach(function (value, n) {
            var option = global.document.createElement('option');
            option.value = value;
            option.textContent = available[n] ? value : value + ' — ' + (card.dataset.clUnavailable || section.dataset.clUnavailable || 'Unavailable');
            option.disabled = !available[n]; // includes a sold-out current choice; the select still shows it until a valid color is picked
            unit.select.appendChild(option);
          });
          unit.signature = signature;
          if (unit.dropdown) unit.dropdown.refresh();
        }
        if (unit.name !== name) {
          unit.slot.replaceChildren(swatchNode(name));
          unit.label.textContent = name;
          unit.node.dataset.clUnitColor = name;
          unit.name = name;
          if (unit.dropdown) { unit.dropdown.update(); unit.dropdown.refresh(); }
        }
        unit.select.value = name;
        unit.node.classList.toggle('is-unavailable', !available[names.findIndex(function (value) { return normalize(value) === normalize(name); })]);
      });
    }
    var dropdownRegistry = global.ClutchLoopUnitDropdown ? global.ClutchLoopUnitDropdown.createRegistry() : null;
    var selectedVariant = null;
    var busy = false;
    var listeners = [];
    var observer = null;

    function on(element, event, callback) {
      if (!element) return;
      element.addEventListener(event, callback);
      listeners.push(function () { element.removeEventListener(event, callback); });
    }

    function money(cents) { return formatMoney(cents, moneyFormat, section.dataset.clShowPriceDecimals === 'true'); }

    function configuration(card) {
      if (!card) return {};
      if (card.dataset.clSimple === 'true') {
        var state = card.dataset.clGiftState || 'none';
        return {
          simple: true,
          automatic: section.dataset.clAutomaticDiscounts === 'true',
          variants: variants,
          colorIndex: colorIndex,
          quantity: card.dataset.clMainQty,
          code: section.dataset.clAutomaticDiscounts === 'true' ? '' : card.dataset.clDiscountCode || '',
          gift: state === 'none' ? null : { state: state, id: Number(card.dataset.clGiftVariantId) || '', quantity: card.dataset.clGiftQuantity }
        };
      }
      var bundleOptions = parseJSON(card.dataset.clBundleOptions, []);
      return {
        match: card.dataset.clPackageMatch,
        bundleVariants: card.hasAttribute('data-cl-bundle-variants') ? parseJSON(card.dataset.clBundleVariants, []) : null,
        bundleColorIndex: bundleOptions.findIndex(function (option) { return normalize(option) === normalize(card.dataset.clBundleColorName); }),
        items: Array.from(card.querySelectorAll('[data-cl-package-item]')).map(function (item) {
          return {
            variants: parseJSON(item.dataset.clItemVariants, []),
            colorIndex: Number(item.dataset.clItemColorOptionIndex),
            quantity: item.dataset.clItemQuantity
          };
        })
      };
    }

    function setImage(gallery, src, alt) {
      var image = gallery.querySelector('[data-cl-gallery-main]');
      if (!image || !src) return;
      image.src = src;
      image.hidden = false;
      var empty = gallery.querySelector('[data-cl-gallery-empty]');
      if (empty) empty.hidden = true;
      image.removeAttribute('srcset');
      image.alt = alt || '';
      image.dataset.clGallerySrc = src;
    }

    function updateGalleries() {
      var variant = resolveVariant(variants, color, colorIndex, '');
      galleries.forEach(function (gallery) {
        var thumbs = Array.from(gallery.querySelectorAll('[data-cl-thumb]'));
        var colored = thumbs.filter(function (thumb) { return normalize(thumb.dataset.clGalleryColor) && normalize(thumb.dataset.clGalleryColor) === normalize(color); });
        var visible = (colored.length ? colored : thumbs.filter(function (thumb) { return !normalize(thumb.dataset.clGalleryColor); })).slice(0, Number(gallery.dataset.clMaxThumbs) || 5);
        thumbs.forEach(function (thumb) {
          var show = visible.indexOf(thumb) !== -1;
          thumb.hidden = !show;
          thumb.tabIndex = show ? 0 : -1;
          thumb.classList.remove('is-active');
          thumb.setAttribute('aria-pressed', 'false');
          var wrapper = thumb.closest('.clp-gallery-item');
          if (wrapper) wrapper.hidden = !show;
        });
        if (visible[0] && colored.length) {
          visible[0].classList.add('is-active');
          visible[0].setAttribute('aria-pressed', 'true');
          setImage(gallery, visible[0].dataset.clImage, visible[0].dataset.clAlt);
        } else if (gallery.dataset.clMainImage) {
          setImage(gallery, gallery.dataset.clMainImage, gallery.dataset.clMainAlt);
        } else if (variant && variant.featured_image && variant.featured_image.src) {
          setImage(gallery, variant.featured_image.src, variant.featured_image.alt);
        } else if (visible[0]) {
          setImage(gallery, visible[0].dataset.clImage, visible[0].dataset.clAlt);
        }
        var cycle = gallery.querySelector('[data-cl-gallery-cycle]');
        if (cycle) {
          cycle.disabled = cycle.dataset.clCycleEnabled !== 'true' || normalize(color) !== normalize(cycle.dataset.clCycleColor) || !cycle.dataset.clCycleFront || !cycle.dataset.clCycleBack;
          cycle.dataset.clSide = 'front';
          if (!cycle.disabled) setImage(gallery, cycle.dataset.clCycleFront, cycle.dataset.clCycleFrontAlt);
        }
      });
    }

    function updateAddons() {
      addons.forEach(function (addon) {
        var input = addon.querySelector('[data-cl-addon-input]');
        var options = parseJSON(addon.dataset.clAddonVariants, []);
        var selector = addon.querySelector('[data-cl-addon-variant]');
        var variant = selector
          ? options.find(function (option) { return String(option.id) === String(selector.value) && option.available; })
          : resolveVariant(options, defaultColor, Number(addon.dataset.clAddonColorOptionIndex), '');
        if (selector) selector.disabled = !options.some(function (option) { return option.available; });
        if (!input) return;
        input.disabled = !variant;
        input.value = variant ? variant.id : '';
        input.dataset.clAddonPrice = variant ? Number(variant.price) * quantity(addon.dataset.clAddonQuantity) : 0;
        if (!variant) input.checked = false;
        addon.classList.toggle('is-unavailable', !variant);
        addon.classList.toggle('is-selected', input.checked);
        var price = addon.querySelector('[data-cl-quick-price]') || addon.querySelector('[data-cl-addon-price]');
        var status = addon.querySelector('[data-cl-addon-status]');
        if (price) price.textContent = variant ? (addon.dataset.clAddonPricePrefix || '') + money(input.dataset.clAddonPrice) : '';
        if (status) status.textContent = variant ? '' : addon.dataset.clAddonSoldOut;
        syncQuickAdd(addon);
      });
    }

    function syncQuickAdd(addon) {
      var button = addon.querySelector('[data-cl-quick-add]');
      var input = addon.querySelector('[data-cl-addon-input]');
      if (!button || !input) return;
      button.disabled = input.disabled;
      button.setAttribute('aria-pressed', String(input.checked));
      var title = addon.querySelector('[data-cl-addon-title]');
      button.setAttribute('aria-label', (input.checked ? 'Remove ' : 'Add ') + (title ? title.textContent.trim() : 'product'));
      button.textContent = input.disabled ? (addon.dataset.clAddonSoldOut || 'Unavailable') : input.checked ? 'Added · Remove' : '+ Add';
    }

    function addonDisplayPrice(addon, input) {
      return addon.dataset.clAddonRecommendation === 'true' ? Number(input.dataset.clAddonPrice) : global.ClutchLoopOffers.price(section, input.dataset.clAddonPrice);
    }

    function updateTotal() {
      global.ClutchLoopOffers.update(section, activeCard && activeCard.dataset.clPackageTitle, !!selectedVariant, money);
      var bundleDisplay = selectedVariant && bundleDisplayPrice(selectedVariant.price, activeCard.dataset.clUnitCount, selectedVariant.simple && section.dataset.clAutomaticDiscounts === 'true');
      var total = bundleDisplay ? bundleDisplay.total : 0;
      anchorError = '';
      anchorGroups.forEach(function (group) {
        var offer = group.update(activeCard);
        total += offer.total;
        if (offer.error) anchorError = offer.error;
      });
      addons.forEach(function (addon) {
        var input = addon.querySelector('[data-cl-addon-input]');
        if (input && input.checked && !input.disabled) total += addonDisplayPrice(addon, input);
      });
      var value = selectedVariant ? Math.max(Number(selectedVariant.price), Number(selectedVariant.compare_at_price) || 0) : 0;
      var products = [];
      if (selectedVariant) {
        var productCount = selectedColors(activeCard).length;
        products.push({ label: productCount + (productCount === 1 ? ' ClutchLoop' : ' ClutchLoops'), rowTitle: 'ClutchLoop', cents: bundleDisplay.total, splitUnits: true, swatches: selectedColors(activeCard).map(function (name) { return { node: swatchNode(name), name: name }; }) });
      }
      if (selectedVariant && selectedVariant.gift && activeCard) {
        value += Number(activeCard.dataset.clGiftValue || 0) * selectedVariant.gift.quantity;
        products.push({ label: selectedVariant.gift.quantity + ' ' + (activeCard.dataset.clGiftTitle || 'Gift') + ' · Free gift', gift: true, cents: 0,
          swatches: [{ image: activeCard.dataset.clGiftImage, name: activeCard.dataset.clGiftTitle || 'Gift' }] });
      }
      anchorGroups.forEach(function (group) { group.current().lines.forEach(function (line) { value += line.original * line.quantity; }); products = products.concat(group.products()); });
      addons.forEach(function (addon) {
        var input = addon.querySelector('[data-cl-addon-input]');
        if (!input || !input.checked || input.disabled) return;
        value += Number(input.dataset.clAddonPrice);
        var img = addon.querySelector('img');
        products.push({ label: addon.querySelector('[data-cl-addon-title]') ? addon.querySelector('[data-cl-addon-title]').textContent : 'Add-on', cents: addonDisplayPrice(addon, input), swatches: img ? [{ image: img.src, name: img.alt }] : [] });
      });
      checkouts.forEach(function (checkout) {
        var offer = checkout.update({ total: total, value: value, bundleDiscountPercent: bundleDisplay ? bundleDisplay.percent : 0, products: products, anchors: anchorGroups, itemMoney: function (cents) { return formatMoney(cents, moneyFormat, true); } });
        total += offer.total;
        if (offer.error) anchorError = offer.error;
      });
      section.querySelectorAll('[data-cl-submit-price]').forEach(function (node) { node.textContent = selectedVariant ? '- ' + money(total) : ''; });
      section.querySelectorAll('[data-cl-submit-saving]').forEach(function (node) {
        var savings = Math.max(0, value - total);
        node.hidden = !selectedVariant || !Number.isFinite(savings) || savings <= 0;
        node.textContent = node.hidden ? '' : 'Saving ' + money(savings);
      });
      section.querySelectorAll('[data-cl-submit-label]').forEach(function (node) {
        node.textContent = busy ? 'Adding…' : confirmedAddition ? 'View Cart'
          : selectedVariant ? (node.dataset.clAvailableLabel || '').replace(/\s*[-–—]\s*$/, '') : node.dataset.clUnavailableLabel;
      });
      var stickyPrice = section.querySelector('[data-cl-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = selectedVariant ? money(total) : '';
      buttons.forEach(function (button) { button.disabled = busy || !selectedVariant || !!anchorError; });
      if (stickyButton) stickyButton.disabled = busy || !selectedVariant || !!anchorError;
      if (stickySelect) {
        stickySelect.value = activeCard ? activeCard.dataset.clPackageKey : '';
        Array.from(stickySelect.options).forEach(function (option) {
          var card = cards.find(function (candidate) { return candidate.dataset.clPackageKey === option.value; });
          option.disabled = false; // Keep invalid combinations selectable so shoppers can edit their colors.
        });
      }
    }

    function updateCommerce() {
      selectionRevision++;
      confirmedAddition = false;
      var resolved = cards.map(function (card) {
        var variant = resolvePackage(configuration(card), selectedColors(card), variants, colorIndex);
        card.classList.toggle('is-unavailable', !variant);
        var input = card.querySelector('[data-cl-package-radio]');
        if (input) input.disabled = false;
        var price = card.querySelector('[data-cl-package-price]');
        var unit = card.querySelector('[data-cl-unit-price]');
        var compare = card.querySelector('[data-cl-compare-price]');
        var display = variant && bundleDisplayPrice(variant.price, card.dataset.clUnitCount, variant.simple && section.dataset.clAutomaticDiscounts === 'true');
        if (price) price.textContent = variant ? money(display.total) + (card.dataset.clTotalLabel ? ' ' + card.dataset.clTotalLabel : '') : card.dataset.clUnavailable || section.dataset.clUnavailable;
        if (unit) unit.textContent = variant ? money(display.unit) + (card.dataset.clUnitLabel || '') : '';
        if (price) price.title = display && display.percent ? 'Includes ' + display.percent + '% bundle discount. Final price confirmed in cart.' : '';
        if (compare) {
          var show = Boolean(variant && card.dataset.clShowCompare === 'true' && (card.dataset.clComparePriceOverride || Number(variant.compare_at_price) > Number(variant.price)));
          compare.hidden = !show;
          compare.textContent = show ? card.dataset.clComparePriceOverride || money(variant.compare_at_price) : '';
        }
        renderColorPill(card);
        var colorError = card.querySelector('[data-cl-color-error]');
        if (colorError) colorError.hidden = !!variant || uniqueColors(selectedColors(card)).length < 2;
        return { card: card, variant: variant };
      });
      var active = resolved.find(function (item) { return item.card === activeCard; });
      selectedVariant = cards.length ? active && active.variant : resolveVariant(variants, color, colorIndex, '');
      cards.forEach(function (card) {
        var selected = card === activeCard;
        card.classList.toggle('is-selected', selected);
        var unitPills = card.querySelector('[data-cl-bundle-swatches]');
        var countLabel = card.querySelector('[data-cl-package-count]');
        if (unitPills) {
          unitPills.hidden = !selected;
          if (!selected) (unitPills._clpUnits || []).forEach(function (unit) {
            if (unit.dropdown) unit.dropdown.close(false);
          });
        }
        if (countLabel) countLabel.hidden = selected;
        var input = card.querySelector('[data-cl-package-radio]');
        if (input) input.checked = selected;
      });
      if (variantInput) variantInput.value = selectedVariant ? selectedVariant.id : '';
      swatches.forEach(function (swatch) {
        var selected = normalize(defaultColor) === normalize(swatch.dataset.clSwatch);
        swatch.classList.toggle('is-selected', selected);
        swatch.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      section.querySelectorAll('[data-cl-swatch-label]').forEach(function (node) { node.textContent = defaultColor; });
      section.querySelectorAll('[data-cl-selected-color-label]').forEach(function (node) { node.textContent = uniqueColors(selectedColors(activeCard)).join(', '); });
      syncColorSwatch(section, swatches, color);
      updateAddons();
      updateTotal();
    }

    function error(message) {
      if (errorNode) { errorNode.textContent = message; errorNode.hidden = false; }
    }

    if (stickySelect) {
      stickySelect.replaceChildren();
      cards.forEach(function (card) {
        var option = global.document.createElement('option');
        option.value = card.dataset.clPackageKey;
        option.textContent = card.dataset.clPackageTitle;
        stickySelect.appendChild(option);
      });
      stickySelect.parentElement.hidden = !cards.length;
      on(stickySelect, 'change', function () {
        var card = cards.find(function (item) { return item.dataset.clPackageKey === stickySelect.value; });
        if (card) activateCard(card);
      });
    }
    swatches.forEach(function (swatch) {
      on(swatch, 'click', function () {
        // Single default for every pack; only per-unit dropdowns create mixed-color packs.
        var picked = swatch.dataset.clSwatch;
        defaultColor = picked;
        cards.forEach(function (card) { colorsByCard.set(card, unitColors([picked], card.dataset.clUnitCount)); });
        color = picked;
        updateCommerce();
        updateGalleries();
      });
    });
    cards.forEach(function (card) {
      on(card, 'click', function (event) {
        if (event.target.closest('a')) return;
        activateCard(card);
      });
      on(card.querySelector('[data-cl-package-radio]'), 'change', function () { activateCard(card); });
    });
    addons.forEach(function (addon) {
      on(addon.querySelector('[data-cl-quick-add]'), 'click', function () {
        var input = addon.querySelector('[data-cl-addon-input]');
        if (input && !input.disabled) input.click();
      });
      on(addon.querySelector('[data-cl-addon-variant]'), 'change', function () {
        updateAddons();
        updateTotal();
      });
      on(addon, 'click', function (event) {
        if (event.target.closest('input, select, option, label, a, button')) return;
        var input = addon.querySelector('[data-cl-addon-input]');
        if (input && !input.disabled) input.click();
      });
      on(addon.querySelector('[data-cl-addon-input]'), 'change', function () {
        addon.classList.toggle('is-selected', addon.querySelector('[data-cl-addon-input]').checked);
        syncQuickAdd(addon);
        updateTotal();
      });
    });
    galleries.forEach(function (gallery) {
      gallery.querySelectorAll('[data-cl-thumb]').forEach(function (thumb) {
        on(thumb, 'click', function () {
          gallery.querySelectorAll('[data-cl-thumb]').forEach(function (other) {
            other.classList.toggle('is-active', other === thumb);
            other.setAttribute('aria-pressed', other === thumb ? 'true' : 'false');
          });
          setImage(gallery, thumb.dataset.clImage, thumb.dataset.clAlt);
        });
      });
      var cycle = gallery.querySelector('[data-cl-gallery-cycle]');
      on(cycle, 'click', function () {
        if (cycle.disabled) return;
        var image = gallery.querySelector('[data-cl-gallery-main]');
        var back = image && image.dataset.clGallerySrc === cycle.dataset.clCycleFront;
        setImage(gallery, back ? cycle.dataset.clCycleBack : cycle.dataset.clCycleFront, back ? cycle.dataset.clCycleBackAlt : cycle.dataset.clCycleFrontAlt);
        gallery.querySelectorAll('[data-cl-thumb]').forEach(function (thumb) { thumb.classList.remove('is-active'); thumb.setAttribute('aria-pressed', 'false'); });
      });
    });
    on(form, 'submit', async function (event) {
      event.preventDefault();
      if (busy) return;
      if (confirmedAddition) {
        busy = true;
        updateTotal();
        try {
          var cart = await global.fetch(cartPath('.js'), { credentials: 'same-origin', cache: 'no-store' }).then(json);
          if (!cart || !Array.isArray(cart.items)) throw new Error('Could not check your cart. Please try again.');
          var mainItems = cartItems(selectedVariant, []);
          if (cart.items.some(function (line) {
            return Number(line.quantity) > 0 && mainItems.some(function (item) { return String(item.id) === String(line.variant_id || line.id); });
          })) {
            await openCart(section, section.dataset.clCartUrl);
            return;
          }
          confirmedAddition = false;
        } catch (exception) {
          error(exception.message || 'Could not check your cart.');
          return;
        } finally {
          busy = false;
          updateTotal();
        }
      }
      updateCommerce();
      var purchaseRevision = selectionRevision;
      if (!selectedVariant) { error(section.dataset.clError); return; }
      if (anchorError) { error(anchorError); return; }
      var addonLines = addons.filter(function (addon) {
        var input = addon.querySelector('[data-cl-addon-input]');
        return input && input.checked && !input.disabled;
      }).map(function (addon) {
        return { id: addon.querySelector('[data-cl-addon-input]').value, quantity: quantity(addon.dataset.clAddonQuantity) };
      });
      var items;
      try { items = cartItems(selectedVariant, addonLines); } catch (exception) { error(exception.message); return; }
      if (!items.length) { error(section.dataset.clError); return; }
      var destination = global.ClutchLoopOffers.cartUrl(section, addonLines.length > 0);
      var packCodes = section.dataset.clAutomaticDiscounts === 'true' ? [] : cards.map(function (card) { return card.dataset.clSimple === 'true' ? String(card.dataset.clDiscountCode || '').trim() : ''; }).filter(Boolean);
      if (errorNode) errorNode.hidden = true;
      busy = true;
      updateTotal();
      buttons.forEach(function (button) { button.setAttribute('aria-busy', 'true'); });
      var purchaseSelection = selectedVariant;
      var flow = Promise.resolve().then(function () {
        return packCodes.length || anchorGroups.length || checkouts.length || purchaseSelection.gift
          ? managedPurchase(purchaseSelection, addonLines, packCodes)
          : post(section.dataset.clCartAddUrl, { items: items }).then(function () { return destination; });
      });
      flow.then(function (target) {
        confirmedAddition = selectionRevision === purchaseRevision;
        if (!confirmedAddition) error('Your previous selection was added. Review your cart before adding the changed selection.');
        return openCart(section, target || destination);
      }).catch(function (exception) {
        error(exception.message || 'Could not add to cart.');
      }).finally(function () {
        busy = false;
        buttons.forEach(function (button) { button.removeAttribute('aria-busy'); });
        updateTotal();
      });
    });
    function post(url, body) {
      return global.fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(json);
    }
    function json(response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
        return data;
      });
    }
    function cartPath(suffix) { return String(section.dataset.clCartUrl || '/cart').replace(/\/$/, '') + suffix; }
    // Removes only lines tagged by this section, one at a time by line key from the latest cart.
    function removeLines(cart, match) {
      var line = (cart.items || []).find(match);
      if (!line) return Promise.resolve(cart);
      return post(cartPath('/change.js'), { id: line.key, quantity: 0 }).then(function (next) { return removeLines(next, match); });
    }
    // Section owns package codes: add tagged lines, apply codes with Shopify's Ajax cart
    // `discount` parameter, then validate the returned cart before redirecting.
    function failure(message, warning) { var e = new Error(message); e.clpWarning = !!warning; return e; }
    // Section owns package codes: add tagged lines, apply codes with Shopify's Ajax cart
    // `discount` parameter, then validate the returned cart before redirecting. Any failure
    // after the add was attempted triggers a verified rollback of this attempt's lines only.
    function managedPurchase(selected, addonLines, packCodes) {
      var token = String(Date.now()) + Math.random().toString(36).slice(2, 8);
      var sectionId = String(section.dataset.sectionId || '');
      var tag = { _clp_section: sectionId, _clp_attempt: token, _clp_pack: activeCard ? activeCard.dataset.clPackageKey : '' };
      var items = packageCartItems(selected, addonLines, tag);
      var anchorPlans = anchorGroups.concat(checkouts).map(function (group) { return { group: group.group, plan: group.current() }; });
      anchorPlans.forEach(function (entry) {
        entry.plan.lines.forEach(function (line) {
          items.push({ id: line.id, quantity: line.quantity, properties: Object.assign({}, tag, {
            _clp_anchor: entry.group, _clp_anchor_role: line.role
          }) });
        });
      });
      var anchorCodes = anchorGroups.concat(checkouts).reduce(function (out, group) { return out.concat(group.codes); }, []);
      var wantedAnchorCodes = anchorPlans.reduce(function (out, entry) { return out.concat(entry.plan.codes); }, []);
      var oldAnchors = [];
      var anchorsTouched = false;
      var ownedAnchor = function (line) {
        var p = lineProps(line);
        return p._clp_section === sectionId && anchorPlans.some(function (entry) { return entry.group === p._clp_anchor; });
      };
      var addonCode = global.ClutchLoopOffers.addonCode ? global.ClutchLoopOffers.addonCode(section, addonLines.length > 0) : '';
      var previous = [];
      var mine = function (line) { return lineProps(line)._clp_attempt === token; };
      var getCart = function () { return global.fetch(cartPath('.js'), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } }).then(json); };
      var check = function (cart) {
        var ownedCodes = packCodes.concat(anchorCodes).map(normalize);
        if (previous.some(function (code) { return ownedCodes.indexOf(normalize(code)) === -1 && !hasCode(cart, code); })) {
          throw failure('Shopify could not retain your existing applied discount together with this offer.');
        }
        if (!anchorPlans.every(function (entry) { return global.ClutchLoopAnchors.verify(cart, sectionId, entry.group, entry.plan, hasCode); })) {
          throw failure('Shopify could not confirm the exact free metal allocation and paid anchor discount. The offer was not accepted; check discount eligibility and combinations.');
        }
        var result = verifyGift(cart, sectionId, token, selected.gift, selected.discountCode);
        if (!result.ok) {
          throw failure(result.reason === 'code'
            ? (section.dataset.clCodeError || 'Shopify did not accept the package discount code, so this package was not added. Please choose another package or contact us.')
            : (section.dataset.clGiftError || 'The free gift could not be confirmed by Shopify (it was not $0), so this package was not added. Please choose another package or contact us.'));
        }
        return cart;
      };
      var added = [];
      // Re-read the cart, remove only this attempt's tagged lines, restore the previous codes and
      // confirm. If confirmation fails, never claim nothing was added.
      function rollback(reason) {
        return getCart().then(function (cart) { return removeLines(cart, mine); }).then(function () {
          // Remove only this group's remaining lines, then restore the saved entitlement/extras.
          if (!anchorsTouched) return;
          return getCart().then(function (cart) { return removeLines(cart, ownedAnchor); }).then(function () {
            if (oldAnchors.length) return post(section.dataset.clCartAddUrl, { items: oldAnchors.map(function (line) {
              return { id: line.variant_id, quantity: line.quantity, properties: line.properties };
            }) });
          });
        }).then(function () {
          if (section.dataset.clAutomaticDiscounts !== 'true') return post(cartPath('/update.js'), { discount: previous.join(',') });
        }).then(getCart).then(function (cart) {
          // Confirm with what Shopify reports: no attempt lines, none of our newly added codes,
          // and every previously known applied code still applied. Otherwise warn.
          if (!Array.isArray(cart.items) || cart.items.some(mine) ||
            added.some(function (code) { return hasCode(cart, code); }) ||
            previous.some(function (code) { return !hasCode(cart, code); })) throw new Error('unconfirmed');
          if (anchorsTouched) {
            var restored = cart.items.filter(ownedAnchor);
            if (restored.length !== oldAnchors.length || oldAnchors.some(function (old) {
              return !restored.some(function (line) {
                return String(line.variant_id) === String(old.variant_id) && line.quantity === old.quantity &&
                  JSON.stringify(line.properties) === JSON.stringify(old.properties) && linePrice(line) === linePrice(old);
              });
            })) throw new Error('unconfirmed');
          }
        }).then(function () {
          throw failure(reason && reason.message ? reason.message : 'Could not add to cart. Nothing from this attempt was kept.');
        }, function () {
          throw failure((reason && reason.message ? reason.message + ' ' : '') + 'We could not confirm the cart was restored — please check your cart before checkout; items or discount codes from this attempt may remain.', true);
        });
      }
      return getCart().then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) {
          throw failure(section.dataset.clUnsupportedCartError || 'Your cart could not be read, so nothing was added. Please refresh and try again.');
        }
        // `discount` replaces all codes: preserve the KNOWN applied codes Shopify reports.
        previous = discountCodes(cart);
        oldAnchors = cart.items.filter(ownedAnchor);
        anchorsTouched = true;
        return removeLines(cart, ownedAnchor).then(function () {
          return post(section.dataset.clCartAddUrl, { items: items });
        }).then(function () {
          if (section.dataset.clAutomaticDiscounts === 'true') return getCart();
          var next = mergeDiscountCodes(previous, packCodes.concat(anchorCodes), [selected.discountCode || '', addonCode].concat(wantedAnchorCodes));
          added = next.split(',').filter(function (code) { return code && !previous.some(function (old) { return normalize(old) === normalize(code); }); });
          return post(cartPath('/update.js'), { discount: next });
        }).then(check).then(function (cart) {
          // Gifts from an earlier pack of this section that are no longer free are removed
          // rather than charged. Only tagged gift lines are touched.
          return removeLines(cart, function (line) {
            var props = lineProps(line);
            return props._clp_section === sectionId && props._clp_gift && props._clp_attempt !== token && linePrice(line) > 0;
          });
        }).then(check) // removeLines returns the latest full cart; revalidate without another request.
          .then(function () { return section.dataset.clCartUrl; }, rollback);
      });
    }
    on(stickyButton, 'click', function () { form.requestSubmit(); });
    if (sticky && buttons[0] && 'IntersectionObserver' in global) {
      observer = new global.IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0.05 });
      observer.observe(buttons[0]);
    }
    section._clpCleanup = function () {
      anchorGroups.forEach(function (group) { group.cleanup(); });
      checkouts.forEach(function (group) { group.cleanup(); });
      if (dropdownRegistry) dropdownRegistry.destroy(); // closes menus, removes portals + listeners
      listeners.forEach(function (remove) { remove(); });
      if (observer) observer.disconnect();
      delete section._clpCleanup;
    };
    updateCommerce();
    updateGalleries();
  }

  function initReviews(root) {
    root.querySelectorAll('[data-clp-reviews]').forEach(function (wrap) {
      if (wrap._clpReviews) return;
      var track = wrap.querySelector('[data-clp-reviews-track]');
      var dotsBox = wrap.querySelector('[data-clp-reviews-dots]');
      if (!track || !dotsBox) return;
      var slides = Array.prototype.slice.call(track.children).filter(function (el) { return el.hasAttribute('data-clp-review-slide') || el.querySelector('[data-clp-review-slide]'); });
      var dots = [];
      var panel = wrap.closest('details');
      var desktopQuery = panel && wrap.closest('.clp-intro-scope') && global.matchMedia ? global.matchMedia('(min-width: 1024px)') : null;
      var mobileOpen = panel ? panel.open : false;
      var summary = panel && panel.querySelector('summary');
      function syncReviewLayout() { if (desktopQuery) panel.open = desktopQuery.matches || mobileOpen; }
      function onReviewToggle() {
        if (!desktopQuery) return;
        if (desktopQuery.matches) { if (!panel.open) panel.open = true; }
        else mobileOpen = panel.open;
      }
      function onReviewSummary(event) { if (desktopQuery && desktopQuery.matches) event.preventDefault(); }
      if (desktopQuery) {
        desktopQuery.addEventListener('change', syncReviewLayout);
        panel.addEventListener('toggle', onReviewToggle);
        if (summary) summary.addEventListener('click', onReviewSummary);
        syncReviewLayout();
      }
      function current() { return track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0; }
      function mark(i) { dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); }); slides.forEach(function (s, n) { s.setAttribute('aria-hidden', n === i ? 'false' : 'true'); }); }
      function go(i) { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: i * track.clientWidth }); mark(i); }
      dotsBox.innerHTML = '';
      slides.forEach(function (slide, i) {
        slide.setAttribute('aria-label', (i + 1) + ' of ' + slides.length);
        var dot = global.document.createElement('button');
        dot.type = 'button'; dot.className = 'clp-reviews-panel__dot';
        dot.setAttribute('aria-label', 'Show review ' + (i + 1) + ' of ' + slides.length);
        dot.addEventListener('click', function () { go(i); });
        dotsBox.appendChild(dot); dots.push(dot);
      });
      dotsBox.hidden = slides.length < 2;
      var raf = 0;
      function onScroll() { if (raf) return; raf = global.requestAnimationFrame(function () { raf = 0; mark(current()); }); }
      function onKeydown(e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(current() + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); go(current() - 1); }
      }
      track.addEventListener('scroll', onScroll, { passive: true });
      track.addEventListener('keydown', onKeydown);
      wrap._clpReviews = {
        go: function (el) { var i = slides.findIndex(function (s) { return s === el || s.contains(el); }); if (i >= 0) go(i); },
        cleanup: function () {
          if (desktopQuery) {
            desktopQuery.removeEventListener('change', syncReviewLayout);
            panel.removeEventListener('toggle', onReviewToggle);
            if (summary) summary.removeEventListener('click', onReviewSummary);
          }
          track.removeEventListener('scroll', onScroll);
          track.removeEventListener('keydown', onKeydown);
          if (raf) global.cancelAnimationFrame(raf);
          delete wrap._clpReviews;
        }
      };
      mark(0);
    });
  }

  function initPreviewLayout(section) {
    if (!section.classList.contains('clp-builder--preview') || section._clpLayoutCleanup) return;
    var title = section.querySelector('.clp-product-info');
    var media = title && title.parentElement;
    var gallery = media && media.querySelector('.clp-gallery');
    // Both current named groups and saved generic groups use this sibling structure.
    var host = media && media.parentElement;
    var purchase = host && Array.from(host.children).find(function (child) {
      return child !== media && child.querySelector('.clp-packages');
    });
    var colors = section.querySelector('.clp-colors');
    if (title && gallery && purchase) {
      title.classList.add('clp-desktop-pinned');
      gallery.classList.add('clp-desktop-pinned-gallery');
    }
    var headers = Array.from(global.document.querySelectorAll('header, .shopify-section-group-header-group, sticky-header'));
    var heroHeader = section.querySelector('.clp-product-header:not(.clp-product-header--in-gallery)');
    var heroMain = heroHeader && section.querySelector('.clp-gallery__main');
    var heroGallery = heroMain && heroMain.closest('.clp-gallery');
    var heroRow = purchase || section.querySelector('.clp-purchase');
    var responsiveTitle = heroGallery && heroGallery.querySelector('.clp-product-header--in-gallery');
    var titleHome = responsiveTitle && responsiveTitle.parentNode;
    var titleNext = responsiveTitle && responsiveTitle.nextSibling;
    var titleDesktop = global.matchMedia('(min-width: 1024px)');
    function placeProductTitle() {
      if (!responsiveTitle || !heroRow) return;
      if (titleDesktop.matches) {
        heroRow.insertBefore(responsiveTitle, heroRow.firstChild);
      } else {
        titleHome.insertBefore(responsiveTitle, titleNext && titleNext.parentNode === titleHome ? titleNext : null);
      }
      schedule();
    }
    titleDesktop.addEventListener('change', placeProductTitle);
    if (heroGallery) {
      section.classList.add('clp-builder--hero-gradient');
      section.style.setProperty('--clp-hero-bg', global.getComputedStyle(heroHeader).getPropertyValue('--ph-bg').trim() || '#dfe8fb');
    }
    function measureHeroGradient() {
      if (!heroGallery) return;
      var sectionTop = section.getBoundingClientRect().top;
      var galleryTop = heroGallery.getBoundingClientRect().top;
      var mainBox = heroMain.getBoundingClientRect();
      // Sticky gallery: use the same-row purchase column top as its natural position so the endpoint stays put.
      var naturalTop = global.getComputedStyle(heroGallery).position === 'sticky' && heroRow ? heroRow.getBoundingClientRect().top : galleryTop;
      var heroTitle = responsiveTitle;
      var gradientEnd = global.matchMedia('(min-width: 1024px)').matches && heroTitle
        ? heroTitle.getBoundingClientRect().bottom - sectionTop
        : naturalTop - sectionTop + (mainBox.top - galleryTop) + mainBox.height / 2;
      section.style.setProperty('--clp-hero-gradient-end', Math.max(0, Math.round(gradientEnd)) + 'px');
    }
    var frame = 0;
    function measure() {
      var sectionStyle = global.getComputedStyle(section);
      var originalPadding = parseFloat(sectionStyle.getPropertyValue('--clp-px-desktop')) || 0;
      var originalMaxWidth = parseFloat(sectionStyle.getPropertyValue('--clp-width')) || 1200;
      section.style.setProperty('--clp-original-content-width', Math.max(0, Math.min(originalMaxWidth, section.clientWidth - originalPadding * 2)) + 'px');
      frame = 0;
      var bottom = 0;
      headers.forEach(function (header) {
        var position = global.getComputedStyle(header).position;
        var box = header.getBoundingClientRect();
        if ((position === 'sticky' || position === 'fixed') && box.top <= 1 && box.bottom > 0) bottom = Math.max(bottom, box.bottom);
      });
      section.style.setProperty('--clp-header-offset', bottom + 'px');
      if (title) section.style.setProperty('--clp-pinned-title-height', (title.querySelector('.clp-product-info__details[open]') ? 0 : title.getBoundingClientRect().height) + 'px');
      if (colors) section.style.setProperty('--clp-quantity-after', global.getComputedStyle(colors).paddingBottom);
      measureHeroGradient();
    }
    function schedule() { if (!frame) frame = global.requestAnimationFrame(measure); }
    var resize = typeof global.ResizeObserver === 'function' ? new global.ResizeObserver(schedule) : null;
    if (resize) [title, colors, heroHeader, heroMain, section].concat(headers).filter(Boolean).forEach(function (node) { resize.observe(node); });
    section.addEventListener('load', schedule, true);
    global.addEventListener('resize', schedule);
    global.addEventListener('scroll', schedule, { passive:true });
    placeProductTitle();
    measure();
    section._clpLayoutCleanup = function () {
      titleDesktop.removeEventListener('change', placeProductTitle);
      if (responsiveTitle && titleHome) titleHome.insertBefore(responsiveTitle, titleNext && titleNext.parentNode === titleHome ? titleNext : null);
      if (resize) resize.disconnect();
      global.cancelAnimationFrame(frame);
      global.removeEventListener('resize', schedule);
      global.removeEventListener('scroll', schedule);
      section.removeEventListener('load', schedule, true);
      section.classList.remove('clp-builder--hero-gradient');
      if (title) title.classList.remove('clp-desktop-pinned');
      if (gallery) gallery.classList.remove('clp-desktop-pinned-gallery');
      delete section._clpLayoutCleanup;
    };
  }
  function initRecommendationEditor(root) {
    if (!global.Shopify || !global.Shopify.designMode) return;
    var panels = Array.from(root.querySelectorAll('[data-cl-more-products]'));
    if (root.matches && root.matches('[data-cl-more-products]')) panels.push(root);
    panels.forEach(function (panel) {
      if (panel._clpRecommendationEditorCleanup) return;
      function select(event) {
        var target = event.target;
        var direct = target.closest && target.closest('[data-cl-more-products]') === panel;
        // Some themes dispatch from a block wrapper rather than the details itself.
        var wrapped = target.contains && target.contains(panel) && event.detail &&
          event.detail.blockId === panel.dataset.clBlockId;
        if (direct || wrapped) panel.open = true;
      }
      global.document.addEventListener('shopify:block:select', select);
      panel._clpRecommendationEditorCleanup = function () {
        global.document.removeEventListener('shopify:block:select', select);
        delete panel._clpRecommendationEditorCleanup;
      };
    });
  }
  function init(root) {
    initRecommendationEditor(root);
    initReviews(root);
    if (root.matches && root.matches('[data-cl-builder]')) startSection(root);
    root.querySelectorAll('[data-cl-builder]').forEach(startSection);
  }
  function startSection(section) {
    initPreviewLayout(section);
    if (section._clpCleanup || section._clpStarting) return;
    section._clpStarting = true;
    var attempts = 0;
    function fail(message, cause) {
      section._clpStarting = false;
      var notice = section.querySelector('[data-cl-error-message]');
      if (notice) { notice.hidden = false; notice.textContent = message; }
      section.querySelectorAll('[data-cl-submit], [data-cl-sticky-submit]').forEach(function (button) { button.disabled = true; });
      if (global.console) global.console.error('ClutchLoop product setup:', cause || message);
    }
    function attempt() {
      if (section.isConnected === false) { section._clpStarting = false; return; }
      var required = [['ClutchLoopOffers', 'clutchloop-offers.js']];
      if (section.querySelector('[data-cl-anchors]')) required.push(['ClutchLoopAnchors', 'clutchloop-anchors.js']);
      if (section.querySelector('[data-cl-checkout]')) required.push(['ClutchLoopCheckout', 'clutchloop-checkout.js'], ['ClutchLoopCheckoutView', 'clutchloop-checkout-view.js']);
      var missing = required.filter(function (entry) { return !global[entry[0]]; });
      if (missing.length) {
        if (++attempts < 50) { global.setTimeout(attempt, 100); return; }
        fail('Product options could not load. Missing theme assets: ' + missing.map(function (entry) { return entry[1]; }).join(', ') + '. Please refresh or contact the store.');
        return;
      }
      try {
        initSection(section);
        section._clpStarting = false;
      } catch (exception) {
        if (section._clpCleanup) section._clpCleanup();
        fail('Product options could not start. Please refresh or contact the store. ' + (global.Shopify && global.Shopify.designMode ? String(exception.message) : ''), exception);
      }
    }
    attempt();
  }
  global.document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  global.document.addEventListener('shopify:block:reorder', function (event) {
    var wrap = event.target.closest && event.target.closest('[data-clp-reviews]');
    if (wrap) { if (wrap._clpReviews) wrap._clpReviews.cleanup(); initReviews(wrap.parentNode); }
  });
  global.document.addEventListener('shopify:section:unload', function (event) {
    var recommendations = Array.from(event.target.querySelectorAll('[data-cl-more-products]'));
    if (event.target.matches && event.target.matches('[data-cl-more-products]')) recommendations.push(event.target);
    recommendations.forEach(function (panel) { if (panel._clpRecommendationEditorCleanup) panel._clpRecommendationEditorCleanup(); });
    var layouts = Array.from(event.target.querySelectorAll('[data-cl-builder]'));
    if (event.target.matches && event.target.matches('[data-cl-builder]')) layouts.push(event.target);
    layouts.forEach(function (section) { if (section._clpLayoutCleanup) section._clpLayoutCleanup(); });
    event.target.querySelectorAll('[data-clp-reviews]').forEach(function (wrap) { if (wrap._clpReviews) wrap._clpReviews.cleanup(); });
    if (event.target.matches && event.target.matches('[data-cl-builder]') && event.target._clpCleanup) event.target._clpCleanup();
    event.target.querySelectorAll('[data-cl-builder]').forEach(function (section) { if (section._clpCleanup) section._clpCleanup(); });
  });
  global.document.addEventListener('shopify:block:select', function (event) {
    var disclosure = event.target.closest && event.target.closest('.clp-what, .clp-reviews-panel');
    if (disclosure) disclosure.open = true;
    var reviews = disclosure && disclosure.querySelector('[data-clp-reviews]');
    if (reviews) {
      initReviews(disclosure);
      var target = event.target;
      global.requestAnimationFrame(function () { if (reviews._clpReviews) reviews._clpReviews.go(target); });
    }
  });
  if (global.document.readyState === 'loading') global.document.addEventListener('DOMContentLoaded', function () { init(global.document); });
  else init(global.document);
})(typeof window !== 'undefined' ? window : globalThis);
